import {Component} from '@angular/core';

@Component({
  selector: 'app-interface-config-help',
  standalone: true,
  imports: [],
  templateUrl: './interface-config-help.component.html',
  styleUrl: './interface-config-help.component.scss'
})
export class InterfaceConfigHelpComponent {

}
